import classNames from 'classnames';
import { Avatar, AvatarProps } from './avatar';

interface AvatarListProps {
  avatars: AvatarProps[];
  maxVisibleCount: number;
  remainingClass?: string;
  children?: React.ReactNode;
}

export const AvatarList: React.FC<AvatarListProps> = ({ avatars, maxVisibleCount, remainingClass, children }) => {
  const visibleAvatars = avatars.slice(0, maxVisibleCount);
  const remainingCount = avatars.length - maxVisibleCount;

  return (
    <div className="flex items-center justify-center">
      <div className="flex items-center justify-center -space-x-1.5">
        {visibleAvatars.map((avatar, index) => (
          <Avatar key={index} {...avatar} />
        ))}
      </div>
      {remainingCount > 0 && (
        <div
          className={classNames(
            'flex items-center justify-center font-medium rounded-full h-6 w-6 ml-1',
            remainingClass
          )}
        >
          +{remainingCount}
        </div>
      )}
      {children && children}
    </div>
  );
};
